import { createSlice } from "@reduxjs/toolkit";
import {
  getNotifications,
  linkFCMToken,
  markNotificationsRead,
} from "../../Api/services/notificationsService";
import toast from "react-hot-toast";

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    isDrawerOpen: false,
    hasUnreadNotifications: false,
    hasBlockingNotifications: false,
    FCMToken: "",
    isTokenLinked: false,
    loading: false,
  },
  reducers: {
    setUnreadNotifications: (state) => {
      state.hasUnreadNotifications = false;
    },
    clearUnreadNotifications: (state) => {
      state.hasUnreadNotifications = false;
    },
    setBlockingNotifications: (state, action) => {
      state.hasBlockingNotifications = action?.payload;
    },
    clearBlockingNotifications: (state) => {
      state.hasBlockingNotifications = false;
    },
    setDrawerOpen: (state) => {
      state.isDrawerOpen = true;
    },
    setDrawerClose: (state) => {
      state.isDrawerOpen = false;
    },
    setFCMToken: (state, action) => {
      state.FCMToken = action?.payload ?? "";
    },
  },
  extraReducers: (builder) => {
    // Get all Certificates Reducer
    builder
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          notifications: action?.payload?.data,
          hasBlockingNotifications: action?.payload?.data?.data?.some(
            (notification) =>
              notification.is_read === false &&
              notification.action_type === "blocking"
          ),
          hasUnreadNotifications: action?.payload?.data?.data?.some(
            (notification) => notification.is_read === false
          ),
        };
      })
      .addCase(getNotifications.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    builder.addCase(markNotificationsRead.fulfilled, (state, action) => {
      if (!state.notifications?.data) return;

      const readNotificationIds = action.meta.arg.id.split(","); // Assuming IDs were sent in the `arg`
      state.notifications.data = state.notifications.data.map((notification) =>
        readNotificationIds.includes(notification.id)
          ? { ...notification, is_read: true }
          : notification
      );

      state.hasBlockingNotifications = state.notifications.data.some(
        (notification) =>
          notification.is_read === false &&
          notification.action_type === "blocking"
      );
      state.hasUnreadNotifications = state.notifications.data.some(
        (notification) => notification.is_read === false
      );
    });
  },
});

export const {
  clearUnreadNotifications,
  setUnreadNotifications,
  setBlockingNotifications,
  setDrawerOpen,
  clearBlockingNotifications,
  setDrawerClose,
  setFCMToken,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
